import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  ImageField,
  ReferenceField,
  Filter,
  ReferenceInput,
  SelectInput,
  BooleanField,
  BooleanInput
} from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCSV } from "react-admin";

const OfferFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      label="Search by User"
      source="user"
      reference="User"
      filter={{
        isMentor: true,
        profileVerified: true,
      }}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <BooleanInput label="Search by Approval" source="isApproved" />
  </Filter>
);

const exporter = (records) => {
  const OfferExport = records.map((record) => {
    console.log("record", record);
    const array = [];
    array.push(record.offerTitle);
    return array;
  });

  const csv = convertToCSV({
    fields: ["Offer"],
    data: OfferExport,
  });

  downloadCSV(csv, "Offers");
};

const OfferList = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    filters={<OfferFilter />}
    exporter={exporter}
  >
    <Datagrid rowClick="show">
      <ImageField
        source="offerImage._url"
        label="Offer View"
        className="thumbNailView"
      />
      <TextField source="offerTitle" label="Offer" />
      <ReferenceField label="User" source="user.id" reference="User">
        <TextField source="name" />
      </ReferenceField>
      <BooleanField label="Approve" source="isApproved" />
    </Datagrid>
  </List>
);

export default OfferList;
